import React, { useState, useEffect } from 'react'
import { Panel, Table, Grid, Row, Col } from 'rsuite'
import { budgetFormat } from '../../utils/formatterUtil'

export default function ListBudgetReportWidget(props) {
  const { schema, header, isCloseProject, isSubpanel } = props
  const { Column, HeaderCell, Cell } = Table

  return (
    <div>
      <Panel
        header={header || schema?.header}
        collapsible
        defaultExpanded
        bordered
        shaded={!isSubpanel}
      >
        <Table
          wordWrap
          autoHeight
          data={schema?.forms?.projectTotalWorkPlan?.values || []}
          style={{ marginTop: '20px' }}
        >
          <Column align="center" width={120} fixed>
            <HeaderCell>
              <span>รหัสแผน</span>
            </HeaderCell>
            <Cell dataKey="masterWorkPlanCode" />
          </Column>

          <Column minWidth={200} width={250} flexGrow={1}>
            <HeaderCell>
              <span>ชื่อแผน</span>
            </HeaderCell>
            {/* <Cell dataKey="workPlanShortName" /> */}
            <Cell>
              {/* {(rowData) => {
                return budgetFormat(rowData.masterPlanBudget)
              }} */}

              {(rowData) => {
                if (rowData.projectVersionId == '') {
                  return (
                    <div style={{ textAlign: 'center' }}>
                      <b>{rowData.workPlanShortName}</b>
                    </div>
                  )
                }

                return rowData.workPlanShortName
              }}
            </Cell>
          </Column>

          <Column width={180} align="right">
            <HeaderCell>
              <span>งบประมาณ</span>
            </HeaderCell>
            <Cell>
              {/* {(rowData) => {
                return budgetFormat(rowData.masterPlanBudget)
              }} */}

              {(rowData) => {
                if (rowData.projectVersionId == '') {
                  return (
                    <span>
                      <b>{budgetFormat(rowData.masterPlanBudget)}</b>
                    </span>
                  )
                }

                return budgetFormat(rowData.masterPlanBudget)
              }}
            </Cell>
          </Column>

          <Column width={150} align="center">
            <HeaderCell>
              <span>ประเภทแผน</span>
            </HeaderCell>
            <Cell dataKey="typeOfPlan" />
          </Column>
        </Table>

        <br />
      </Panel>
    </div>
  )
}
